import React from 'react'
import clsx from 'clsx'

import {AppListProps, List_TYPE} from './AppListProps'

import './AppListStyles.scss'


export const AppList = (props: AppListProps) => {

    const {
        listType = List_TYPE.ORDERD,
        children,
        className,
        ...rest
    } = props

    return (
        <>
            {
                (listType === List_TYPE.ORDERD) ?
                    <ol className={clsx("app-ordered-list", className)} {...rest}>
                        {children}
                    </ol>
                    :
                    ((listType === List_TYPE.ORDERD_WITH_ICONS) ?
                            <ol className={clsx("app-ordered-with-icon-list", className)} {...rest}>
                                {children}
                            </ol> :
                            <ul className={clsx("app-unordered-list", className)} {...rest}>
                                {children}
                            </ul>
                    )
            }
        </>
    )
        ;
};